import React from 'react';
import { SelecaoModeloInteresseConsumer } from './SelecaoModeloInteresseConsumer';

export const withSelecaoModeloInteresse = Component => props => (
  <SelecaoModeloInteresseConsumer>
    <Component {...props} />
  </SelecaoModeloInteresseConsumer>
);
